import * as React from 'react';
import {IAddBoxPayload} from "src/store/actions";
import {EFruits} from "src/store/enums";
import {getId} from "src/utils/utils";

interface IProps {
  defaultKind: EFruits;
  defaultSize: number;
  shelfId?: string;
  addBox?: (arg: IAddBoxPayload) => void;
}

export class FruitBox extends React.Component<IProps, {}> {

  private id = getId('FruitBox');

  public componentWillMount() {
    const {shelfId, defaultKind, defaultSize, addBox} = this.props;
    if (addBox && shelfId) {
      addBox({shelfId, boxId: this.id, defaultKind, defaultSize})
    }
  }

  public render() {
    const {children, ...otherProps} = this.props;
    return (
      <>
        {React.Children.map(children, (child: any) => React.cloneElement(child, {...otherProps, boxId: this.id}))}
      </>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/abstract/FruitBox.tsx